module.exports = __webpack_public_path__ + "img/1ne.107c3547.svg";